import React, { useState, useEffect, useCallback, forwardRef } from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Textarea from '@mui/joy/Textarea';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';



//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';




///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

//////////////////// APi
import { sectionUpdate, getsection } from '../../Api/common';

const schema = yup.object({
    content_ar: yup.string().required("هذا الحقل مطلوب"),
    content_en: yup.string().required("هذا الحقل مطلوب"),

})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function InputsFieldsSectionThree() {
    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    
    const form = useForm({
        defaultValues: {
            content_ar: "",
            content_en: "",
            type: '2'
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState

    const getOldDataSection = useCallback(async () => {
        const res = await getsection('2');
        if (res) {
            setValue('content_ar', res.content_ar)
            setValue('content_en', res.content_en)
        }
    }, []);

    const submitUpdateContentSectionTwo = async (data) => {
        setLoading(true)
        try {
            const res = await sectionUpdate(data)
            if (res) {
                setOpenAlert(true)
                setMessageAlert("تم تعديل محتوى القسم الثالث بنجاح")
                setLoading(false)
                getOldDataSection();
            }
        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    };

    const handleClick = () => {
        setOpenAlert(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    useEffect(() => {
        getOldDataSection();
    }, [getOldDataSection]);

    return (
        <>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>

            <form onSubmit={handleSubmit(submitUpdateContentSectionTwo)}>
                <FormControl>
                    <FormLabel>تفاصيل القسم</FormLabel>
                    <Textarea
                        placeholder="لتقييم السيارات الفارهة والغير موجودة في النظام يرجى التواصل معنا عبر (واتس اب او بريد الكتروني) وسيتم التعامل مع المعلومات بكل سرية وخصوصية كاملة ، علما ان هذه الخدمة ستكون مدفوعة الاجر بسعر مخفض لفترة محدودة"
                        minRows={4}
                        sx={{
                            '--Textarea-focusedInset': 'var(--any, )',
                            '--Textarea-focusedThickness': '0.25rem',
                            '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                            '&::before': {
                                transition: 'box-shadow .15s ease-in-out',
                            },
                            '&:focus-within': {
                                borderColor: '#86b7fe',
                            },
                            borderRadius: '15px'
                        }}
                        {...register('content_ar')}
                    />
                </FormControl>
                {errors.content_ar &&
                    <Typography
                        color="danger"
                        level="body-xs"
                        variant="plain"
                    >{errors.content_ar?.message}</Typography>
                }


                <FormControl sx={{ direction: 'ltr', marginTop: '10px' }}>
                    <FormLabel>Details</FormLabel>
                    <Textarea
                        placeholder="Details Placeholder"
                        minRows={4}
                        sx={{
                            '--Textarea-focusedInset': 'var(--any, )',
                            '--Textarea-focusedThickness': '0.25rem',
                            '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                            '&::before': {
                                transition: 'box-shadow .15s ease-in-out',
                            },
                            '&:focus-within': {
                                borderColor: '#86b7fe',
                            },
                            borderRadius: '15px'
                        }}
                        {...register('content_en')}
                    />
                </FormControl>
                {errors.content_en &&
                    <Typography
                        color="danger"
                        level="body-xs"
                        variant="plain"
                    >{errors.content_en?.message}</Typography>
                }
                <Button
                    variant='solid'
                    type='submit'
                    loading={loading}
                    sx={{ marginTop: '30px', backgroundColor: '#3E64F4', color: '#FFF', height: '60px', borderRadius: '30px' }}>
                    تجديد محتوى القسم الثالث
                </Button>
            </form>
        </>

    )
}